import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const ONCELIK_RENK = {
  dusuk: { bg: '#F3F4F6', text: '#6B7280', label: 'Dusuk' },
  normal: { bg: '#EEF2FF', text: '#4F46E5', label: 'Normal' },
  yuksek: { bg: '#FEF3C7', text: '#D97706', label: 'Yuksek' },
  acil: { bg: '#FEE2E2', text: '#DC2626', label: 'Acil' },
};

const DURUM_RENK = {
  bekliyor: { bg: '#F3F4F6', text: '#6B7280', label: 'Bekliyor' },
  hr_onayinda: { bg: '#EEF2FF', text: '#4F46E5', label: 'HR Onayinda' },
  yonetim_onayinda: { bg: '#FEF3C7', text: '#D97706', label: 'Yonetim Onayinda' },
  onaylandi: { bg: '#D1FAE5', text: '#059669', label: 'Onaylandi' },
  reddedildi: { bg: '#FEE2E2', text: '#DC2626', label: 'Reddedildi' },
  iptal: { bg: '#F3F4F6', text: '#9CA3AF', label: 'Iptal' },
};

const Badge = ({ durum, tip = 'durum' }) => {
  const map = tip === 'durum' ? DURUM_RENK : ONCELIK_RENK;
  const d = map[durum] || { bg: '#F3F4F6', text: '#6B7280', label: durum };
  return <span style={{ background: d.bg, color: d.text, padding: '3px 10px', borderRadius: '99px', fontSize: '12px', fontWeight: '600', whiteSpace: 'nowrap', display: 'inline-block' }}>{d.label}</span>;
};

const BOŞ_FORM = { talep_turu: 'inhouse', baslik: '', aciklama: '', departman_id: '', pozisyon_id: '', musteri_id: '', pozisyon_adi: '', pozisyon_aciklama: '', adet: 1, oncelik: 'normal', hedef_baslangic: '' };

const KadroFormu = ({ form, setForm, duzenleId, yukleniyor, departmanlar, pozisyonlar, musteriler, onSubmit, onKapat }) => (
  <div className="card" style={{ marginBottom: '1.5rem', borderLeft: '4px solid var(--mavi)' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
      <h3 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>{duzenleId ? 'Talebi Duzenle' : 'Yeni Kadro Talebi'}</h3>
      <button className="btn btn-secondary btn-sm" onClick={onKapat}>Kapat</button>
    </div>
    <form onSubmit={onSubmit}>
      <div className="form-grid">
        <div className="form-group full">
          <label>Talep Turu *</label>
          <div style={{ display: 'flex', gap: '1rem' }}>
            {['inhouse', 'outsource'].map(tur => (
              <label key={tur} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '10px 16px', border: '1.5px solid ' + (form.talep_turu === tur ? 'var(--mavi)' : 'var(--border)'), borderRadius: '8px', background: form.talep_turu === tur ? 'var(--mavi-acik)' : '#fff', flex: 1 }}>
                <input type="radio" value={tur} checked={form.talep_turu === tur} onChange={e => setForm(f => ({ ...f, talep_turu: e.target.value, departman_id: '', pozisyon_id: '', musteri_id: '', pozisyon_adi: '' }))} style={{ display: 'none' }} />
                <span style={{ fontSize: '14px', fontWeight: '500', color: form.talep_turu === tur ? 'var(--mavi)' : 'var(--yazi)' }}>
                  {tur === 'inhouse' ? 'Inhouse' : 'Outsource'}
                </span>
              </label>
            ))}
          </div>
        </div>

        <div className="form-group full">
          <label>Baslik *</label>
          <input type="text" value={form.baslik} onChange={e => setForm(f => ({ ...f, baslik: e.target.value }))} required placeholder="Talep basligini girin" />
        </div>

        {form.talep_turu === 'inhouse' && (
          <>
            <div className="form-group">
              <label>Departman *</label>
              <select value={form.departman_id} onChange={e => setForm(f => ({ ...f, departman_id: e.target.value, pozisyon_id: '' }))} required>
                <option value="">-- Departman secin --</option>
                {departmanlar.filter(d => d.aktif).map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Pozisyon</label>
              <select value={form.pozisyon_id} onChange={e => setForm(f => ({ ...f, pozisyon_id: e.target.value }))} disabled={!form.departman_id}>
                <option value="">-- Pozisyon secin --</option>
                {pozisyonlar.map(p => <option key={p.id} value={p.id}>{p.ad}</option>)}
              </select>
            </div>
          </>
        )}

        {form.talep_turu === 'outsource' && (
          <>
            <div className="form-group">
              <label>Musteri *</label>
              <select value={form.musteri_id} onChange={e => setForm(f => ({ ...f, musteri_id: e.target.value }))} required>
                <option value="">-- Musteri secin --</option>
                {musteriler.filter(m => m.durum === 'aktif').map(m => <option key={m.id} value={m.id}>{m.firma_adi}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Pozisyon Adi *</label>
              <input type="text" value={form.pozisyon_adi} onChange={e => setForm(f => ({ ...f, pozisyon_adi: e.target.value }))} required placeholder="or. Senior Backend Developer" />
            </div>
            <div className="form-group full">
              <label>Pozisyon Aciklamasi</label>
              <textarea value={form.pozisyon_aciklama} onChange={e => setForm(f => ({ ...f, pozisyon_aciklama: e.target.value }))} rows={2} placeholder="Gereksinimler, tecrubu vs..." />
            </div>
          </>
        )}

        <div className="form-group">
          <label>Oncelik</label>
          <select value={form.oncelik} onChange={e => setForm(f => ({ ...f, oncelik: e.target.value }))}>
            <option value="dusuk">Dusuk</option>
            <option value="normal">Normal</option>
            <option value="yuksek">Yuksek</option>
            <option value="acil">Acil</option>
          </select>
        </div>
        <div className="form-group">
          <label>Adet</label>
          <input type="number" min="1" value={form.adet} onChange={e => setForm(f => ({ ...f, adet: e.target.value }))} />
        </div>
        <div className="form-group">
          <label>Hedef Baslangic Tarihi</label>
          <input type="date" value={form.hedef_baslangic} onChange={e => setForm(f => ({ ...f, hedef_baslangic: e.target.value }))} />
        </div>
        <div className="form-group full">
          <label>Aciklama</label>
          <textarea value={form.aciklama} onChange={e => setForm(f => ({ ...f, aciklama: e.target.value }))} rows={2} placeholder="Ek bilgi..." />
        </div>
      </div>
      <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
        <button type="submit" className="btn btn-primary" disabled={yukleniyor}>
          {yukleniyor ? 'Kaydediliyor...' : duzenleId ? 'Guncelle' : 'Talebi Olustur'}
        </button>
        <button type="button" className="btn btn-secondary" onClick={onKapat}>Iptal</button>
      </div>
    </form>
  </div>
);

const KadroTalepleriPage = () => {
  const [talepler, setTalepler] = useState([]);
  const [departmanlar, setDepartmanlar] = useState([]);
  const [pozisyonlar, setPozisyonlar] = useState([]);
  const [musteriler, setMusteriler] = useState([]);
  const [formAcik, setFormAcik] = useState(false);
  const [duzenleId, setDuzenleId] = useState(null);
  const [detayId, setDetayId] = useState(null);
  const [detay, setDetay] = useState(null);
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [filtre, setFiltre] = useState('hepsi');
  const [onayNotu, setOnayNotu] = useState('');
  const [form, setForm] = useState(BOŞ_FORM);

  const [kullanici] = useState(() => JSON.parse(localStorage.getItem('kullanici') || '{}'));
  const rol = kullanici.rol;

  const yukle = () => axios.get('/api/kadro').then(r => setTalepler(r.data)).catch(console.error);

  const stableSetForm = React.useCallback((updater) => {
    setForm(prev => typeof updater === 'function' ? updater(prev) : updater);
  }, []);

  useEffect(() => {
    yukle();
    axios.get('/api/organizasyon/departmanlar').then(r => setDepartmanlar(r.data)).catch(console.error);
    axios.get('/api/musteriler').then(r => setMusteriler(r.data)).catch(console.error);
  }, []);

  useEffect(() => {
    if (form.departman_id) {
      axios.get('/api/organizasyon/pozisyonlar?departman_id=' + form.departman_id)
        .then(r => setPozisyonlar(r.data)).catch(console.error);
    } else { setPozisyonlar([]); }
  }, [form.departman_id]);

  useEffect(() => {
    if (detayId) {
      axios.get('/api/kadro/' + detayId).then(r => setDetay(r.data)).catch(console.error);
    }
  }, [detayId]);

  const formAc = (talep = null) => {
    if (talep) {
      setDuzenleId(talep.id);
      setForm({
        talep_turu: talep.talep_turu,
        baslik: talep.baslik,
        aciklama: talep.aciklama || '',
        departman_id: talep.departman_id || '',
        pozisyon_id: talep.pozisyon_id || '',
        musteri_id: talep.musteri_id || '',
        pozisyon_adi: talep.pozisyon_adi || '',
        pozisyon_aciklama: talep.pozisyon_aciklama || '',
        adet: talep.adet || 1,
        oncelik: talep.oncelik || 'normal',
        hedef_baslangic: talep.hedef_baslangic || '',
      });
    } else {
      setDuzenleId(null);
      setForm(BOŞ_FORM);
    }
    setFormAcik(true);
    setSonuc(null);
  };

  const formKapat = () => { setFormAcik(false); setDuzenleId(null); setForm(BOŞ_FORM); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setYukleniyor(true); setSonuc(null);
    try {
      if (duzenleId) {
        await axios.put('/api/kadro/' + duzenleId, form);
        setSonuc({ tip: 'basari', mesaj: 'Talep guncellendi.' });
      } else {
        await axios.post('/api/kadro', form);
        setSonuc({ tip: 'basari', mesaj: 'Kadro talebi olusturuldu.' });
      }
      formKapat();
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleOnay = async (karar) => {
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.post('/api/kadro/' + detayId + '/onay', { karar, aciklama: onayNotu });
      setSonuc({ tip: 'basari', mesaj: karar === 'onayla' ? 'Talep onaylandi.' : 'Talep reddedildi.' });
      setOnayNotu('');
      axios.get('/api/kadro/' + detayId).then(r => setDetay(r.data));
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleIptal = async (id) => {
    if (!window.confirm('Talebi iptal etmek istediginize emin misiniz?')) return;
    try {
      await axios.delete('/api/kadro/' + id);
      setSonuc({ tip: 'basari', mesaj: 'Talep iptal edildi.' });
      if (detayId === id) setDetayId(null);
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
  };

  const filtrelenmis = talepler.filter(t => filtre === 'hepsi' ? true : t.durum === filtre);

  const bekleyenOnayim = (talep) => {
    if (talep.durum === 'hr_onayinda' && rol === 'hr_super') return true;
    if (talep.durum === 'yonetim_onayinda' && rol === 'admin') return true;
    return false;
  };

  const duzenlenebilir = (talep) => {
    if (rol === 'admin') return true;
    if (!['bekliyor', 'hr_onayinda', 'yonetim_onayinda'].includes(talep.durum)) return false;
    if (rol === 'hr_super') return true;
    if (String(talep.olusturan_id) === String(kullanici.id)) return true;
    return false;
  };

  // DETAY SAYFASI
  if (detayId && detay) {
    const { talep, onaylar } = detay;
    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '8px' }}>
          <button className="btn btn-secondary btn-sm" onClick={() => { setDetayId(null); setDetay(null); setSonuc(null); }}>← Listeye Don</button>
          <div style={{ display: 'flex', gap: '8px' }}>
            {duzenlenebilir(talep) && (
              <button className="btn btn-secondary btn-sm" onClick={() => { setDetayId(null); setDetay(null); formAc(talep); }}>Duzenle</button>
            )}
            {(String(talep.olusturan_id) === String(kullanici.id) || rol === 'admin') && ['bekliyor', 'hr_onayinda'].includes(talep.durum) && (
              <button className="btn btn-danger btn-sm" onClick={() => handleIptal(talep.id)}>Iptal Et</button>
            )}
          </div>
        </div>

        {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
            <div>
              <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '6px' }}>{talep.baslik}</h2>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <Badge durum={talep.durum} tip="durum" />
                <Badge durum={talep.oncelik} tip="oncelik" />
                <span style={{ fontSize: '12px', fontWeight: '600', padding: '3px 10px', borderRadius: '99px', background: talep.talep_turu === 'inhouse' ? '#EEF2FF' : '#F0FDF4', color: talep.talep_turu === 'inhouse' ? '#4F46E5' : '#059669' }}>
                  {talep.talep_turu === 'inhouse' ? 'Inhouse' : 'Outsource'}
                </span>
              </div>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.75rem', marginBottom: '1rem' }}>
            {[
              { label: 'Talep Turu', value: talep.talep_turu === 'inhouse' ? 'Inhouse' : 'Outsource' },
              { label: 'Adet', value: talep.adet },
              { label: 'Oncelik', value: talep.oncelik },
              { label: 'Hedef Baslangic', value: talep.hedef_baslangic || '-' },
              { label: 'Departman', value: talep.departman_ad || '-' },
              { label: 'Pozisyon', value: talep.pozisyon_sistem_adi || talep.pozisyon_adi || '-' },
              { label: 'Musteri', value: talep.musteri_ad || '-' },
              { label: 'Olusturan', value: talep.olusturan_ad },
            ].map(item => (
              <div key={item.label} style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '0.6rem 0.75rem' }}>
                <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', marginBottom: '2px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{item.label}</div>
                <div style={{ fontSize: '13px', fontWeight: '500' }}>{item.value}</div>
              </div>
            ))}
          </div>

          {talep.aciklama && (
            <div style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '0.75rem 1rem', fontSize: '13px' }}>
              <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', marginBottom: '4px', textTransform: 'uppercase' }}>Aciklama</div>
              {talep.aciklama}
            </div>
          )}
        </div>

        {onaylar && onaylar.length > 0 && (
          <div className="card" style={{ marginBottom: '1.5rem' }}>
            <h3 style={{ fontSize: '15px', fontWeight: '600', marginBottom: '1rem' }}>Onay Akisi</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {onaylar.map((o, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', background: 'var(--gri-50)', borderRadius: '8px' }}>
                  <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: o.durum === 'onaylandi' ? '#D1FAE5' : o.durum === 'reddedildi' ? '#FEE2E2' : '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', flexShrink: 0 }}>
                    {o.durum === 'onaylandi' ? '✓' : o.durum === 'reddedildi' ? '✗' : o.adim_sira}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', fontWeight: '500' }}>{o.adim_baslik}</div>
                    {o.onaylayan_ad && <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{o.onaylayan_ad} • {o.onay_tarihi ? new Date(o.onay_tarihi).toLocaleDateString('tr-TR') : ''}</div>}
                    {o.aciklama && <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>Not: {o.aciklama}</div>}
                  </div>
                  <Badge durum={o.durum} tip="durum" />
                </div>
              ))}
            </div>
          </div>
        )}

        {bekleyenOnayim(talep) && (
          <div className="card" style={{ borderLeft: '4px solid var(--mavi)' }}>
            <h3 style={{ fontSize: '15px', fontWeight: '600', marginBottom: '1rem' }}>Onay Ver</h3>
            <div className="form-group" style={{ marginBottom: '1rem' }}>
              <label>Not (opsiyonel)</label>
              <textarea value={onayNotu} onChange={e => setOnayNotu(e.target.value)} rows={2} placeholder="Onay notu..." />
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button className="btn btn-primary" disabled={yukleniyor} onClick={() => handleOnay('onayla')} style={{ flex: 1 }}>✓ Onayla</button>
              <button className="btn btn-danger" disabled={yukleniyor} onClick={() => handleOnay('reddet')} style={{ flex: 1 }}>✗ Reddet</button>
            </div>
          </div>
        )}
      </div>
    );
  }

  // LİSTE SAYFASI
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Kadro Talepleri</h2>
          <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Inhouse ve outsource kadro taleplerini yonetin.</p>
        </div>
        {['admin', 'hr_super', 'yonetici'].includes(rol) && (
          <button className="btn btn-primary" onClick={() => formAc()}>+ Yeni Kadro Talebi</button>
        )}
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      {formAcik && (
        <KadroFormu
          key={duzenleId || 'yeni'}
          form={form}
          setForm={stableSetForm}
          duzenleId={duzenleId}
          yukleniyor={yukleniyor}
          departmanlar={departmanlar}
          pozisyonlar={pozisyonlar}
          musteriler={musteriler}
          onSubmit={handleSubmit}
          onKapat={formKapat}
        />
      )}

      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '1rem' }}>
        {[
          { key: 'hepsi', label: 'Hepsi' },
          { key: 'hr_onayinda', label: 'HR Onayinda' },
          { key: 'yonetim_onayinda', label: 'Yonetim Onayinda' },
          { key: 'onaylandi', label: 'Onaylandi' },
          { key: 'reddedildi', label: 'Reddedildi' },
        ].map(f => (
          <button key={f.key} className={'btn btn-sm ' + (filtre === f.key ? 'btn-primary' : 'btn-secondary')} onClick={() => setFiltre(f.key)}>
            {f.label}
          </button>
        ))}
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {filtrelenmis.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>
            <div style={{ fontSize: '32px', marginBottom: '8px' }}>📋</div>
            Kadro talebi bulunamadi.
          </div>
        ) : (
          <div className="tablo-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Talep</th>
                  <th>Tur</th>
                  <th>Departman / Musteri</th>
                  <th>Pozisyon</th>
                  <th>Adet</th>
                  <th>Oncelik</th>
                  <th>Durum</th>
                  <th>Olusturan</th>
                  <th>Tarih</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filtrelenmis.map(t => (
                  <tr key={t.id} onClick={() => setDetayId(t.id)} style={{ cursor: 'pointer' }}>
                    <td style={{ fontWeight: '500', fontSize: '14px' }}>
                      {t.baslik}
                      {bekleyenOnayim(t) && <span style={{ marginLeft: '6px', background: '#FEF3C7', color: '#D97706', fontSize: '10px', padding: '1px 6px', borderRadius: '4px', fontWeight: '700' }}>ONAY BEKLIYOR</span>}
                    </td>
                    <td style={{ whiteSpace: 'nowrap' }}>
                      <span style={{ fontSize: '12px', fontWeight: '600', color: t.talep_turu === 'inhouse' ? '#4F46E5' : '#059669', whiteSpace: 'nowrap' }}>
                        {t.talep_turu === 'inhouse' ? 'Inhouse' : 'Outsource'}
                      </span>
                    </td>
                    <td style={{ fontSize: '13px' }}>{t.departman_ad || t.musteri_ad || '-'}</td>
                    <td style={{ fontSize: '13px' }}>{t.pozisyon_sistem_adi || t.pozisyon_adi || '-'}</td>
                    <td style={{ fontSize: '13px', textAlign: 'center', whiteSpace: 'nowrap' }}>{t.adet}</td>
                    <td style={{ whiteSpace: 'nowrap' }}><Badge durum={t.oncelik} tip="oncelik" /></td>
                    <td style={{ whiteSpace: 'nowrap' }}><Badge durum={t.durum} tip="durum" /></td>
                    <td style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{t.olusturan_ad}</td>
                    <td style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{t.olusturma_tarihi ? new Date(t.olusturma_tarihi).toLocaleDateString('tr-TR') : '-'}</td>
                    <td style={{ whiteSpace: 'nowrap' }} onClick={e => e.stopPropagation()}>
                      {duzenlenebilir(t) && (
                        <button className="btn btn-secondary btn-sm" onClick={() => formAc(t)}>Duzenle</button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default KadroTalepleriPage;
